import { render, staticRenderFns } from "./view-returnOrder.vue?vue&type=template&id=615014a4&"
import script from "./view-returnOrder.vue?vue&type=script&lang=ts&"
export * from "./view-returnOrder.vue?vue&type=script&lang=ts&"
import style0 from "./view-returnOrder.vue?vue&type=style&index=0&id=615014a4&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports